import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Text } from '@chakra-ui/react';
import { formatCurrency, formatPrice } from '@whitbread-eos/utils';
import React, { useCallback, useEffect, useState } from 'react';
import RoomCardHeader from './RoomCardHeader.component';
import RoomCardInfo from './RoomCardInfo.component';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function RoomCard(_ref) {
  var room = _ref.room,
    roomNumber = _ref.roomNumber,
    currency = _ref.currency,
    t = _ref.t,
    currentLang = _ref.currentLang,
    taxesMessage = _ref.taxesMessage,
    brand = _ref.brand,
    isCardExpanded = _ref.isCardExpanded,
    cardsExpanded = _ref.cardsExpanded,
    setCardsExpanded = _ref.setCardsExpanded,
    handleExpandCollapse = _ref.handleExpandCollapse;
  var roomReservationStartDate = room.roomReservationStartDate,
    roomReservationEndDate = room.roomReservationEndDate,
    leadGuestTitle = room.leadGuestTitle,
    leadGuestName = room.leadGuestName,
    roomType = room.roomType,
    roomTypeDescription = room.roomTypeDescription,
    rateType = room.rateType,
    rateTypeDescription = room.rateTypeDescription,
    roomGroup = room.roomGroup,
    roomTotalPrice = room.roomTotalPrice,
    ratesPerNight = room.ratesPerNight,
    adultMealDescription = room.adultMealDescription,
    childrenMealDescription = room.childrenMealDescription,
    mealPrice = room.mealPrice,
    extrasRoomSelection = room.extrasRoomSelection,
    packagesExtrasItems = room.packagesExtrasItems;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showRoomCardInfo = _useState2[0],
    setShowRoomCardInfo = _useState2[1];
  var createCardsArray = useCallback(() => {
    if (cardsExpanded.length === 0) {
      setCardsExpanded(prevState => [...prevState, {
        roomNumber: roomNumber,
        expanded: showRoomCardInfo
      }]);
    }
  }, [cardsExpanded.length]);
  useEffect(() => {
    setShowRoomCardInfo(isCardExpanded);
  }, [isCardExpanded]);
  useEffect(() => {
    createCardsArray();
  }, [createCardsArray]);
  var roomCardHeaderData = {
    roomReservationStartDate,
    roomReservationEndDate,
    roomNumber,
    roomTotalPrice,
    currency,
    currentLang,
    t,
    showRoomCardInfo,
    handleExpandCollapse
  };
  var roomCardInfoData = {
    leadGuestTitle,
    leadGuestName,
    roomType,
    roomTypeDescription,
    rateType,
    rateTypeDescription,
    roomGroup,
    roomReservationEndDate,
    roomTotalPrice,
    roomNumber,
    ratesPerNight,
    adultMealDescription,
    childrenMealDescription,
    mealPrice,
    extrasRoomSelection,
    packagesExtrasItems,
    taxesMessage,
    brand,
    currency,
    currentLang,
    t
  };
  return _jsxs(_Fragment, {
    children: [_jsx(Box, _objectSpread(_objectSpread({}, roomCardStyle), {}, {
      sx: {
        '@media print': {
          display: 'none'
        }
      },
      children: _jsxs(Flex, _objectSpread(_objectSpread({}, roomCardDetailsStyle), {}, {
        children: [_jsx(RoomCardHeader, _objectSpread({}, roomCardHeaderData)), showRoomCardInfo && _jsx(RoomCardInfo, _objectSpread({}, roomCardInfoData))]
      }))
    })), _jsxs(Box, {
      display: "none",
      sx: {
        '@media print': {
          display: 'block',
          my: 'md'
        }
      },
      children: [_jsx(Text, {
        mb: "sm",
        fontWeight: "bold",
        children: t('booking.confirmation.room').replace('[roomNumber]', roomNumber.toString())
      }), _jsxs(Text, {
        fontWeight: "bold",
        children: [leadGuestTitle, " ", leadGuestName]
      }), _jsx(Text, {
        children: roomGroup
      }), _jsxs(Flex, {
        justifyContent: "space-between",
        fontSize: "md",
        children: [_jsx(Text, {
          children: roomType
        }), _jsx(Text, {
          fontWeight: "bold",
          children: formatPrice(formatCurrency(currency), room === null || room === void 0 ? void 0 : room.roomTotalPrice.toFixed(2), currentLang)
        })]
      })]
    })]
  });
}
var roomCardStyle = {
  mb: 'md',
  w: 'full',
  border: '1px solid',
  borderColor: 'lightGrey3',
  borderRadius: '3px'
};
var roomCardDetailsStyle = {
  direction: 'column',
  w: 'full'
};